
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { secureOpenUrl } from '@/utils/linkValidation';

interface NavItem {
  name: string;
  href: string;
  hasDropdown?: boolean;
  isNcolo?: boolean;
  subItems?: { name: string; href: string }[];
}

interface MobileMenuProps {
  isOpen: boolean;
  navItems: NavItem[];
  onNavClick: (item: NavItem) => void;
  onScheduleClick: () => void;
  onClose: () => void;
}

const MobileMenu = ({ isOpen, navItems, onNavClick, onScheduleClick, onClose }: MobileMenuProps) => {
  if (!isOpen) return null;

  const handleScheduleClick = () => {
    window.open('https://tidycal.com/nexx-telecom/30-minute-meeting-m72ke5v', '_blank');
    onClose();
  };

  const handleLoginClick = () => {
    secureOpenUrl('https://acc.nexx.net/clientarea.php');
    onClose();
  };

  return (
    <div className="lg:hidden" id="mobile-menu">
      <div className="px-2 pt-2 pb-3 space-y-3 bg-white border-t">
        {navItems.map((item) => (
          <div key={item.name}>
            {item.hasDropdown ? (
              <div className="space-y-2">
                <div className="px-3 py-2 text-gray-600 font-medium">{item.name}</div>
                <div className="ml-4 space-y-2">
                  {item.subItems?.map((subItem) => (
                    <Link
                      key={subItem.name}
                      to={subItem.href}
                      className="block px-3 py-2 text-sm text-gray-600 hover:text-nexx-green transition-colors duration-200"
                      onClick={onClose}
                    >
                      {subItem.name}
                    </Link>
                  ))}
                </div>
              </div>
            ) : (
              item.href.startsWith('/') && !item.isNcolo ? (
                <Link
                  to={item.href}
                  className="block px-3 py-2 text-gray-600 hover:text-nexx-green transition-colors duration-200"
                  onClick={onClose}
                >
                  {item.name}
                </Link>
              ) : (
                <button
                  onClick={() => {
                    onNavClick(item);
                    onClose();
                  }}
                  className={`block px-3 py-2 text-gray-600 hover:text-nexx-green transition-colors duration-200 w-full text-left ${
                    item.isNcolo ? 'hover:text-blue-600' : ''
                  }`}
                >
                  {item.name}
                  {item.isNcolo && (
                    <span className="text-xs text-blue-600 ml-2">Powered by NCOLO</span>
                  )}
                </button>
              )
            )}
          </div>
        ))}
        <div className="pt-4 space-y-3">
          <Button 
            variant="outline" 
            className="w-full border-nexx-green text-nexx-green hover:bg-nexx-green hover:text-white"
            onClick={handleScheduleClick}
          >
            Schedule Meeting
          </Button>
          <Button 
            className="w-full bg-nexx-green hover:bg-green-700 text-white"
            data-tally-open="3NQKvW" 
            data-tally-emoji-text="👋" 
            data-tally-emoji-animation="wave"
          >
            Get Trial
          </Button>
          <Button 
            variant="ghost" 
            className="w-full text-gray-600"
            onClick={handleLoginClick}
          >
            Login
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
